import { immediateToast } from "izitoast-react";

export const urlCopyToClipboard=(text)=>{
    navigator.clipboard.writeText(text);
    immediateToast("success", {
        message: 'Link copied.',
    });
 }